// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EntityLanguagesLabel__entityLanguagesLabel___1o_tP{font-size:14px;color:#666}\n", ""]);
// Exports
exports.locals = {
	"entityLanguagesLabel": "EntityLanguagesLabel__entityLanguagesLabel___1o_tP"
};
module.exports = exports;
